import { type MaybeRefOrGetter, type Ref, computed, toRef } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { refDebounced } from '@vueuse/core'

export const useEffectivePriceInput = (
  priceInput: Ref<[number, number]>,
  maxPrice: MaybeRefOrGetter<number | undefined>,
) => {
  const experiments = useExperiments()
  const withoutDuplicatedCallsBug =
    experiments['experiment.plpDuplicatedAlgoliaCalls'] ===
    'withoutDuplicatedCalls'
  const maxPriceRef = toRef(maxPrice)
  const debouncedPriceInput = refDebounced(priceInput, 500)

  const isPriceFiltered = computed(() => {
    if (withoutDuplicatedCallsBug) {
      if (!maxPriceRef.value) return false

      return (
        priceInput.value[0] > 0 ||
        (priceInput.value[1] > 0 && priceInput.value[1] !== maxPriceRef.value)
      )
    }

    return priceInput.value[0] > 0 || priceInput.value[1] > 0
  })

  return computed<[number, number] | undefined>(() =>
    isPriceFiltered.value ? debouncedPriceInput.value : undefined,
  )
}
